<template>
  <b-modal
    id="analytics-code-modal"
    class="custom-modal"
    title="Analytics Code"
    size="lg"
    centered
    no-close-on-backdrop
    @shown="setForm"
    @hidden="clearModal"
  >
    <b-form>
      <b-row no-gutters class="mb-3">
        <b-col sm="12" md="3">
          <h6 class="primary-label">Facebook Pixel ID</h6>
        </b-col>
        <b-col>
          <b-row>
            <b-col>
              <b-form-group label-for="input-code-snippets">
                <b-form-input type="text"
                  id="input-code-snippets"
                  v-model="form.fb_pixel_id"
                  :maxlength="maxInputCodeSnippetsLength"
                  placeholder="Type Here"
                  :state="isInvalid('fb_pixel_id')"
                >
                </b-form-input>
                <b-form-invalid-feedback :state="isInvalid('fb_pixel_id')">
                  {{ errorMessage("fb_pixel_id") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row no-gutters class="mb-3">
        <b-col sm="12" md="3">
          <h6 class="primary-label">AAM Code</h6>
        </b-col>
        <b-col>
          <b-row>
            <b-col>
              <b-form-group label-for="input-code-snippets">
                <b-form-input type="text"
                  id="input-code-snippets"
                  v-model="form.aam_code"
                  :maxlength="maxInputCodeSnippetsLength"
                  placeholder="Type Here"
                  :state="isInvalid('aam_code')"
                >
                </b-form-input>
                <b-form-invalid-feedback :state="isInvalid('aam_code')">
                  {{ errorMessage("aam_code") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row no-gutters class="mb-3">
        <b-col sm="12" md="3">
          <h6 class="primary-label">Google Code</h6>
        </b-col>
        <b-col>
          <b-row>
            <b-col>
              <b-form-group label-for="input-code-snippets">
                <b-form-input type="text"
                  id="input-code-snippets"
                  v-model="form.google_code"
                  :maxlength="maxInputCodeSnippetsLength"
                  placeholder="Type Here"
                  :state="isInvalid('google_code')"
                >
                </b-form-input>
                <b-form-invalid-feedback :state="isInvalid('google_code')">
                  {{ errorMessage("google_code") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <b-container fluid>
        <b-row>
          <b-col xs="12" md="4" class="mb-3 mb-md-0">
            <b-btn
              variant="ghost"
              class="btn-block btn-cancel"
              @click="$root.$emit('bv::hide::modal', 'analytics-code-modal')"
            >
              Cancel
            </b-btn>
          </b-col>
          <b-col xs="12" md="4" class="ml-md-auto text-md-right">
            <b-btn
              variant="primary"
              class="btn-block"
              @click="validateField"
              :disabled="isLoading"
            >
              {{ isLoading ? "Saving..." : "Save" }}
            </b-btn>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import notification from "@/services/notification";
import Vue from "vue";

function initForm() {
    return {
        fb_pixel_id: null,
        aam_code: null,
        google_code: null
    };
}
export default {
    name: "AnalyticsCodeModal",
    data() {
        return {
            form: initForm(),
            maxInputCodeSnippetsLength: 3000
        };
    },
    computed: {
        ...mapGetters("surveys", ["errors", "isLoading", "pageDetails"])
    },
    methods: {
        ...mapMutations("surveys", ["setErrors"]),
        ...mapActions("surveys", ["updatePage"]),
        setForm() {
            if (this.pageDetails.analytics_code) {
                this.form.fb_pixel_id = this.pageDetails.analytics_code[0].fb_pixel_id;
                this.form.aam_code = this.pageDetails.analytics_code[1].aam_code;
                this.form.google_code = this.pageDetails.analytics_code[2].google_code;
            }
        },
        isInvalid(field) {
            if (this.errors === null) {
                return null;
            } else {
                return !Object.keys(this.errors).includes(field)
                    ? null
                    : !Object.keys(this.errors).includes(field);
            }
        },
        errorMessage(field) {
            if (this.errors === null) {
                return "";
            } else if (Object.keys(this.errors).includes(field)) {
                return Array.isArray(this.errors[field])
                    ? this.errors[field].join(" ")
                    : this.errors[field];
            }
        },
        validateField() {
            const errors = {};
            // const form = this.form;
            // Object.keys(form).map(field => {
            //   if (!form[field])
            //     errors[field] = "Code snippets is required";
            // });

            // const scriptTags = {
            //   script: ["<script>", "<\/script>"],
            //   noscript: ["<noscript>", "<\/noscript>"]
            // };

            const codeError = [];

            // Object.keys(scriptTags).map(groupTag => {
            //   const tagCollection = {};
            //   scriptTags[groupTag].map(tag => {
            //     tagCollection[tag] = {
            //       tag: tag,
            //       status: form.code.includes(tag)
            //     };
            //   });
            //   const collection = {};
            //   Object.keys(tagCollection).map(key => {
            //     if (!Object.keys(collection).includes(key.replace(/\W/g, "")))
            //       Vue.set(collection, key.replace(/\W/g, ""), []);

            //     collection[key.replace(/\W/g, "")].push(tagCollection[key].status);

            //     if (collection[key.replace(/\W/g, "")].includes(true) && collection[key.replace(/\W/g, "")].includes(false)) {
            //       codeError.push(`Missing opening/closing tag for ${key.replace(/\W/g, "")}.`);
            //     } else if (collection[key.replace(/\W/g, "")].includes(false) && collection[key.replace(/\W/g, "")].includes(false)) {
            //       errors["code"] = "Must be a valid script.";
            //     }
            //   });
            // });

            if (codeError.length > 0) errors["code"] = codeError;

            this.setErrors(errors);

            if (Object.keys(errors).length === 0) this.submitForm();
            else notification.warning("Oops, cannot save code snippets.");
        },
        async submitForm() {
            const page = this.pageDetails;
            const payload = {
                pageId: page.uuid,
                pageName: page.page_name,
                hidePreviousButton: page.hide_prev_button,
                surveyId: this.$route.params.uuid,
                analytics_code: [
                    {
                        fb_pixel_id: this.form.fb_pixel_id
                    },
                    {
                        aam_code: this.form.aam_code
                    },
                    {
                        google_code: this.form.google_code
                    }
                ]
            };
            await this.updatePage(payload).then(() => {
                if (
                    this.errors === null ||
                    Object.keys(this.errors).length === 0
                )
                    this.$root.$emit("bv::hide::modal", "analytics-code-modal");
            });
        },
        clearModal() {
            this.setErrors(null);
            this.form = initForm();
        }
    }
};
</script>

<style>
</style>
